
import './App.css';
import { Curriculum } from './Componentes/Curriculum';
import { MisRutas } from './Router/MisRutas';

function App() {
  return (
    <div className='layout'>
      <MisRutas/>
    </div>
  );
}

export default App;
